export default __webpack_public_path__ + "static/01_heroBusiness-4c52b7e6756dbe0ab07480437404fd72.jpg";